import FinancialQuarter from "./FinancialQuarter"

function FinancialYear({
  data,
  selectedYearIndex,
  locale,
}: {
  data: any
  selectedYearIndex: string
  locale: string
}) {
  return (
    <>
      {data.map((item: any, index: number) => (
        <FinancialQuarter
          index={index}
          locale={locale}
          data={item}
          visible={item.year === selectedYearIndex}
          key={index}
        />
      ))}
    </>
  )
}

export default FinancialYear
